module.exports = __webpack_public_path__ + "static/media/video-clock.e6af82b4.mov";